import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import objectFitImages from 'object-fit-images';
// import gsap from 'gsap';
import Inputmask from 'inputmask';
import validate from 'jquery-validation';
import Scrollbar, {ScrollbarPlugin} from 'smooth-scrollbar';
import AOS from 'aos';
// import objectFitVideos from 'object-fit-videos';

class ModalPlugin extends ScrollbarPlugin {
	static pluginName = 'modal';

	static defaultOptions = {
		open: false,
	};

	transformDelta(delta) {
		return this.options.open ? {
			x: 0,
			y: 0,
		} : delta;
	}
}

/* eslint-disable */
class SoftScrollPlugin extends Scrollbar.ScrollbarPlugin {
	transformDelta(delta) {
		const dirX = delta.x > 0 ? 1 : -1;
		const dirY = delta.y > 0 ? 1 : -1;

		if (dirX === this.lockX || dirY === this.lockY) {
			return {x: 0, y: 0};
		} else {
			this.lockX = null;
			this.lockY = null;
		}

		return delta;
	}

	onRender(Data2d) {
		const {x, y} = Data2d;

		// Up
		if (y < 0 && !this.lockY && Math.abs(y) >= this.scrollbar.scrollTop) {
			this.scrollbar.setMomentum(0, -this.scrollbar.scrollTop);
			this.lockY = -1;
		}

		// Left
		if (x < 0 && !this.lockX && Math.abs(x) >= this.scrollbar.scrollLeft) {
			this.scrollbar.setMomentum(-this.scrollbar.scrollLeft, 0);
			this.lockX = -1;
		}

		// Right
		if (x > 0 && !this.lockX && Math.abs(x) >= (this.scrollbar.limit.x - this.scrollbar.scrollLeft)) {
			this.scrollbar.setMomentum((this.scrollbar.limit.x - this.scrollbar.scrollLeft), 0);
			this.lockX = 1;
		}

		// Down
		if (y > 0 && !this.lockY && Math.abs(y) >= (this.scrollbar.limit.y - this.scrollbar.scrollTop)) {
			this.scrollbar.setMomentum(0, (this.scrollbar.limit.y - this.scrollbar.scrollTop));
			this.lockY = 1;
		}

		if(y === 0) this.lockY = null;
		if(x === 0) this.lockX = null;
	}
}

SoftScrollPlugin.pluginName = 'SoftScroll';
/* eslint-enable */
/* eslint-disable no-undef */

Scrollbar.use(ModalPlugin, SoftScrollPlugin);

svg4everybody();
objectFitImages();
// objectFitVideos();

window.$ = $;
window.jQuery = $;
window.objectFitImages = objectFitImages;
// window.gsap = gsap;
window.Inputmask = Inputmask;
window.validate = validate;
let isMobile = () => innerWidth <= 1024;
const scrollContainer = document.querySelector('#scroll');
const scrollbarParams = {
	damping: 0.1,
	renderByPixel: true,
	continuousScrolling: true,
	alwaysShowTracks: true,
};

window.scrollbar = {};

function scrollUpdate() {
	if (isMobile()) {
		if (Object.keys(scrollbar).length !== 0) {
			Scrollbar.destroy(scrollContainer);
		}
		$(scrollContainer).removeAttr('data-scrollbar tabindex style');

		// scrollContainer.style.height = 'auto !important';
		// setTimeout(() => {
		// 	document.querySelector('.scroll-content').style.transform = 'none';
		// }, 500);
	} else {
		// scrollContainer.style.height = '100vh';
		window.scrollbar = Scrollbar.init(scrollContainer, scrollbarParams);
	}
}

scrollUpdate();
window.addEventListener('resize', scrollUpdate);

window.AOS = AOS;

AOS.init({
	offset: -120,
	once: true,
	duration: 1000,
	easing: 'ease-out',
	throttleDelay: 300,
});
// window.objectFitVideos = objectFitVideos;

require('ninelines-ua-parser');
